console.debug("LOADING App.tsx")
import { CssBaseline } from "@mui/material"
import { ThemeProvider } from "@mui/material/styles"
import { CreateComponent, rootStore, BrowserSupport, OnboardingModal, WaitForInit, QlRouter, routeStore, ConnectionMonitor,
			firstInstallStore, FirstInstall, configFirstRun, QlRouterProvider, Login, NavBar, OverlayEventDetails} from "./"
import { DiscoverModal } from "scenes/Discover/DiscoverModal"
import React from "react"
import { appFeatures } from "AppFeatures"
import { analyticsScreen, analyticsMeta } from "store/qlapi/LogService"
import "./site-ql/style.css"
import { theme } from "./site-ql/theme"
import { PreviousLocationProvider } from "hooks/PreviousLocationProvider"
import { localStorage } from "store/util/LocalStorage"
import { PersistentCanvas } from "scenes/Radio/Radio"

const styles = (theme: any) => ({
	// MTVW-881: maxWidth: "100%" to make sure that vertical scrollbar width is not counted for "100vw"
	pageWrapper: { height: "100%", width: "100vw", maxWidth: "100%",  margin: "0px auto"},
	page: { height: "100%", overflow: "hidden" },
	"@global": {
		"#root": {
			height: "100%"
		}
	},
	Player: {
		position: "absolute",
		width: 920,
		top: 90,
		left: "50%",
		marginLeft: -512,
		transition: "all 0.5s linear"
	},
	PlayerOverlay: {
		margin: 0,
		bottom: 10,
		top: "auto",
		position: "fixed",
		left: 10,
		transition: "all 0.5s linear",
		width: 400
	}
})

export const App = CreateComponent(styles, false, true, ({ classes }: any) => {

	// MTVW-1000: moved from LoginService
	const [initPending, setInitPending] = React.useState(true)
	const [initDone, setInitDone] = React.useState(false)
	React.useEffect(() => {
		//console.debug("App useEffect initPending %s, isAuthenticated %s, changeProfile %s, isFirstInstall %s, CoCoBookmarks.refreshCount %s", initPending, rootStore.sso.isAuthenticatedProfile, rootStore.sso.changeProfile, firstInstallStore.isFirstInstall, rootStore.page.CoCoBookmarks.refreshCount)
		if (initPending /*&& !firstInstallStore.isFirstInstall*/ && rootStore.sso.isAuthenticatedProfile) {
			console.debug("load: completeInit")
			completeInit().then((res) =>
				setInitDone(true)
			)
		}
		else {
			//rootStore.setIsLoading(true)
			//console.debug("load: initDone")
			//setInitDone(true)
		}
		console.debug("load: initPending=", initPending)
		if (initPending && rootStore.sso.isAuthenticatedProfile) {
			console.debug("load: setInitPending false")
			setInitPending(false)
		}
		//setInitPending(firstInstallStore.isFirstInstall)
		return (() => {

		})
	}, [firstInstallStore.isFirstInstall, rootStore.sso.isAuthenticatedProfile, rootStore.sso.changeProfile])

	const completeInit = async () => {
		//if (rootStore.page.CoCoBookmarks.refreshCount <= 1) {
		//console.debug("completeInit")
		rootStore.setIsLoading(true)
		// MTVW-966: avoid error when reloading page in ChannelListEditor
		if (localStorage.get("restorePath")) {
			rootStore.sso.selectPath(localStorage.get("restorePath"))
			localStorage.remove("restorePath")
		}
		// MTVW-921: added yield, otherwise initial bookmarks fetch could use the outdated profileId after a profile change
		await rootStore.page.CoCoBookmarks.init()
		await rootStore.page.CoCoDiscover.init()
		const unused = await appFeatures.checkTraxisOnStartup()
		rootStore.logService.analyticsScreenview({ [analyticsMeta.screen]: analyticsScreen.login })
		// MTVW-1094
		appFeatures.applyPersistentSettings()
		// MTVW-1013
		await rootStore.channelsService.init()
		//console.debug("loginAsync:", rootStore.channelsService.getFirstChannelListChannel)
		rootStore.channelsService.setActiveChannel(rootStore.channelsService.getFirstChannelListChannel)
		rootStore.waitForTimeSync.setResolve()
		// delay before spinner is turned off, otherwise potential PinEntryDialog may disappear and flash again
		//if (!rootStore.channelsService.activeChannelId) rootStore.channelsService.setActiveChannel(rootStore.channelsService.getFirstChannel ? rootStore.channelsService.getFirstChannel.id : null)
		//await rootStore.page.MsEpg.getProgramsForNow()
		//setTimeout(() => {
			rootStore.setIsLoading(false)
		//}, 500)
		//}
	}

	return (
		<ThemeProvider theme={theme}>
			<ConnectionMonitor isShow={false} />
			<CssBaseline />
				<QlRouterProvider value={routeStore}>
					<WaitForInit>
						<BrowserSupport />
						{/* MTVW-157: TODO checks for this.browserStore.currentProfileId? */}
						{!rootStore.sso.isAuthenticatedProfile ? (
							<Login store={rootStore} />
						) : (
							<>
								{firstInstallStore.isFirstInstall ? (
									<FirstInstall config={configFirstRun()} />
								) : (
									<>
									{rootStore.page.Onboarding.hasBlockingAnnouncement ? (
										<OnboardingModal />
									) : (
										<>
										{rootStore.page.Onboarding.hasNonBlockingAnnouncement ? (
											<OnboardingModal />
										) : <></>
										}
										{/* MTVW-966: PreviousLocationProvider */}
										<PreviousLocationProvider>		
										{/* MTVW-754 trial */}
										<div /*style={{
											display: "flex",
											justifyContent: "center",
											alignItems: "center"}} className={classes.page}*/>
											<NavBar />
											<div /*style={{ position: "relative", margin: "0 auto", width: "80vw"}}*/
												id="pageWrapper" className={classes.pageWrapper} /*style={{ width: "100vw" }}*/ >
												{/* MTVW-966: initDone */}
												{initDone &&
													<QlRouter />
												}	
												{/*<Router {...test} />*/}
											</div>
											{/*<div className={classes.Player}><Player page={rootStore.page.Player} /></div>*/}
										</div>
										</PreviousLocationProvider>
										{/*<PersistentCanvas />*/} {/* never unmounts */}
										<OverlayEventDetails isShow={true} />
										<DiscoverModal isShow={false} />
										</>
								)}
									</>
								)}
							</>
						)}
					</WaitForInit>
				</QlRouterProvider>
		</ThemeProvider>
	)
})
